<div #button class="meatball-button" data-princexml-ignore data-html2canvas-ignore (click)="toggleOpen()" [attr.data]="MEATBALL_ID">
	<app-icon
		[name]="orientation === 'H' ? 'meatball-menu' : 'meatball-menu-vertical'"
		[size]="size === 'L' ? 'large' : 'small'"
		color="typography-5"
		hoverColor="typography-2"
	></app-icon>
</div>
<ng-template #dropdown>
	<div class="dropdown-anchor">
		<div
			class="dropdown"
			[delayClickOutsideInit]="true"
			(clickOutside)="hide()"
			[clickOutsideEvents]="'click,touchend'"
			(click)="hide()"
			[class.rounded-corners]="rounded"
		>
			<ng-content></ng-content>
		</div>
	</div>
</ng-template>
